function updateBannerHeight() {
  const mediaElement = document.querySelector('#product-grid .product-card-media');
  const mediaMobileElement = document.querySelector('#product-grid .product-card-media-mobile');
  const bannerElements = document.querySelectorAll('.grid__item--banner');
  if (window.innerWidth < 769) {
    if (mediaMobileElement && bannerElements.length > 0) {
      const height = mediaMobileElement.offsetHeight;
      bannerElements.forEach(element => {
        element.style.setProperty('--banner-height', `${height}px`);
      });
    }
  }
  else {
    if (mediaElement && bannerElements.length > 0) {
      const height = mediaElement.offsetHeight;
      bannerElements.forEach(element => {
        element.style.setProperty('--banner-height', `${height}px`);
      });
    }
  }
}

function initInfiniteScroll() {
  const target = document.querySelector('#infinite-scroll-target');
  const loading = document.querySelector('#loading');
  const productGrid = document.querySelector('#product-grid');
  const paginationDataElement = document.querySelector('#pagination-data');
  const end_of_page_element = document.querySelector('.next-collection-container');

  if (!target || !paginationDataElement) {
    console.warn('Infinite scroll: Missing target or pagination data element.');
    return;
  }

  let { nextPageUrl, currentPage, totalPages } = JSON.parse(paginationDataElement.textContent);
  let isLoading = false;

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting && nextPageUrl && !isLoading && currentPage < totalPages) {
        isLoading = true;
        loading.style.display = 'block';
        fetch(nextPageUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
          })
          .then((data) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');

            const newPaginationData = doc.querySelector('#pagination-data');
            const items = [...doc.querySelectorAll('#product-grid product-card-component')];

            // Reserve product positions
            const placeholders = [];

            items.forEach(() => {
              const wrapper = document.createElement('div');
              wrapper.className = 'grid__item';
              productGrid.appendChild(wrapper);
              placeholders.push(wrapper);
            });

            // Load all products in parallel
            items.forEach((item, index) => {
              const productLink = item.querySelector('a')?.getAttribute('href');
              if (!productLink) return;

              const handle = productLink.replace('/products/', '').split('?')[0];
              const fetchUrl = `${window.Shopify.routes.root}products/${handle}?section_id=product-card-clp-section`;

              fetch(fetchUrl)
                .then((res) => {
                  if (!res.ok) {
                    throw new Error(`Failed to load ${handle}`);
                  }
                  return res.text();
                })
                .then((html) => {
                  const newDoc = new DOMParser().parseFromString(html, 'text/html');
                  const cardHTML = newDoc.querySelector(
                    '#shopify-section-product-card-clp-section'
                  )?.innerHTML;

                  if (cardHTML) {
                    placeholders[index].innerHTML = cardHTML;
                    updateBannerHeight();
                  }
                })
                .catch((err) => {
                  console.error('Error loading product card:', err);
                  placeholders[index].remove();
                });
              });
            infinitePage++;
            if (newPaginationData) {
              const newData = JSON.parse(newPaginationData.textContent);
              nextPageUrl = newData.nextPageUrl;
              currentPage = newData.currentPage;
              totalPages = newData.totalPages;
            } else {
              nextPageUrl = null;
              target.style.display = 'none';
              end_of_page_element.classList.remove('hidden');
            }
            updateBannerHeight();
            isLoading = false;
            loading.style.display = 'none';
          })
          .catch((error) => {
            console.error('Error fetching next page:', error);
            isLoading = false;
            loading.style.display = 'none';
          });
      }
    },
    {
      root: null,
      rootMargin: '800px',
      threshold: 0,
    }
  );
  observer.observe(target);
}

document.addEventListener('DOMContentLoaded', () => {
  updateBannerHeight();
  initInfiniteScroll();
});

let infinitePage = 1;

if (document.querySelector("#infinite-scroll-target")) {
  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  window.addEventListener("scroll", () => {
    if (window.isRestoring) return;

    sessionStorage.setItem("infScrollY", window.scrollY);
    sessionStorage.setItem("infPage", infinitePage);
  });
}
